import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const Timer = z.object({
    taskCode: z.string(),
    elapsedSeconds: z.number(),
});

export type Timer = z.infer<typeof Timer>;
